import SearchModalMain from "./SearchModalMain";

export default SearchModalMain;
